module.exports = __webpack_public_path__ + "static/media/header_registration.a3406573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_registration.jpg
// module id = 416
// module chunks = 0